__turbopack_context__.v({
  "circleIcon": "style-module-scss-module__62WJFq__circleIcon",
  "closeButton": "style-module-scss-module__62WJFq__closeButton",
  "closeContainer": "style-module-scss-module__62WJFq__closeContainer",
  "closing": "style-module-scss-module__62WJFq__closing",
  "columnSection": "style-module-scss-module__62WJFq__columnSection",
  "detailsOptionButton": "style-module-scss-module__62WJFq__detailsOptionButton",
  "detailsOptionButtonActive": "style-module-scss-module__62WJFq__detailsOptionButtonActive",
  "detailsOptionButtons": "style-module-scss-module__62WJFq__detailsOptionButtons",
  "detailsOptionTabButton": "style-module-scss-module__62WJFq__detailsOptionTabButton",
  "detailsOptionTabButtonActive": "style-module-scss-module__62WJFq__detailsOptionTabButtonActive",
  "detailsOptionTabs": "style-module-scss-module__62WJFq__detailsOptionTabs",
  "detailsOptions": "style-module-scss-module__62WJFq__detailsOptions",
  "foreCastDetails": "style-module-scss-module__62WJFq__foreCastDetails",
  "foreCastDetailsItem": "style-module-scss-module__62WJFq__foreCastDetailsItem",
  "getAppCard": "style-module-scss-module__62WJFq__getAppCard",
  "getAppContainer": "style-module-scss-module__62WJFq__getAppContainer",
  "labelContainer": "style-module-scss-module__62WJFq__labelContainer",
  "learnMoreButton": "style-module-scss-module__62WJFq__learnMoreButton",
  "learnMoreButtonContainer": "style-module-scss-module__62WJFq__learnMoreButtonContainer",
  "loadingContainer": "style-module-scss-module__62WJFq__loadingContainer",
  "loadingIcon": "style-module-scss-module__62WJFq__loadingIcon",
  "locationDetailsContainer": "style-module-scss-module__62WJFq__locationDetailsContainer",
  "metarDetails": "style-module-scss-module__62WJFq__metarDetails",
  "metarDetailsContent": "style-module-scss-module__62WJFq__metarDetailsContent",
  "metarDetailsDescription": "style-module-scss-module__62WJFq__metarDetailsDescription",
  "metarDetailsDescriptionContainer": "style-module-scss-module__62WJFq__metarDetailsDescriptionContainer",
  "metarDetailsDescriptionLabel": "style-module-scss-module__62WJFq__metarDetailsDescriptionLabel",
  "metarDetailsHeader": "style-module-scss-module__62WJFq__metarDetailsHeader",
  "metarDetailsItemInfo": "style-module-scss-module__62WJFq__metarDetailsItemInfo",
  "metarDetailsItemInfoLabel": "style-module-scss-module__62WJFq__metarDetailsItemInfoLabel",
  "metarDetailsItemInfoLabelContainer": "style-module-scss-module__62WJFq__metarDetailsItemInfoLabelContainer",
  "metarDetailsItemInfoValue": "style-module-scss-module__62WJFq__metarDetailsItemInfoValue",
  "metarDetailsTitle": "style-module-scss-module__62WJFq__metarDetailsTitle",
  "metarDetailsTitleCircle": "style-module-scss-module__62WJFq__metarDetailsTitleCircle",
  "metarDetailsTitleContainer": "style-module-scss-module__62WJFq__metarDetailsTitleContainer",
  "metarDetailsTitleSub": "style-module-scss-module__62WJFq__metarDetailsTitleSub",
  "noDataContent": "style-module-scss-module__62WJFq__noDataContent",
  "noDataDescription": "style-module-scss-module__62WJFq__noDataDescription",
  "noDataSection": "style-module-scss-module__62WJFq__noDataSection",
  "noDataTitle": "style-module-scss-module__62WJFq__noDataTitle",
  "opening": "style-module-scss-module__62WJFq__opening",
  "section": "style-module-scss-module__62WJFq__section",
  "stationCode": "style-module-scss-module__62WJFq__stationCode",
  "stationName": "style-module-scss-module__62WJFq__stationName",
  "stationNameContainer": "style-module-scss-module__62WJFq__stationNameContainer",
});
